export const logoConstants = {
  LOGO: "LOGO",
};
